import { Button, Divider, Icon } from '@advanza/ui'
import AutoRow from 'components/misc/AutoRow'
import ServicesPlacesContentBlocks from 'components/seo/ServicesPlacesContentBlocks'
import ServicesSelect from 'components/services/ServicesSelect'
import Page from 'components/ui/Page'
import SearchLocationInput from 'components/ui/SearchLocationInput'
import { useCurrentCountry, useUrlQuery } from 'hooks/miscHooks'
import React from 'react'

// Matches the service select the place picker stands beside.
const PLACE_PICKER_SETTINGS = { inputFieldHeight: 38 }

const SEOServicesPlacesContentsPage = ({}) => {
    const { query, onSetQuery } = useUrlQuery({})
    const countryCode = useCurrentCountry()
    return (
        <Page title="SEO Service Places Content Page">
            <Divider xl />
            <AutoRow>
                <h2>SEO service/place content blocks </h2>
                <div> </div>
                <ServicesSelect
                    placeholder={false}
                    multiple={false}
                    onChangeValue={(service) => onSetQuery({ service })}
                    value={query.service}
                />
                <div> </div>
                <Icon name="place" />
                <SearchLocationInput
                    className="w-[200px]"
                    settings={PLACE_PICKER_SETTINGS}
                    countryCode={countryCode}
                    onChangeLocation={(place) =>
                        onSetQuery({
                            place: place.url_name,
                            placeName: place.place_name,
                        })
                    }
                    value={query.placeName || query.place}
                />
                <Button name="text" onClick={() => onSetQuery({ place: '', placeName: '' })}>
                    <Icon name="south_america" />
                </Button>
            </AutoRow>
            <Divider xxl name="border" />
            <ServicesPlacesContentBlocks place={query.place} service={query.service} />
        </Page>
    )
}

export default SEOServicesPlacesContentsPage
